"use client";

import { Color } from "@whitecircle/graphql/graphql";
import { cva, cx } from "class-variance-authority";

import {
	Text,
	UNSTABLE_Toast as Toast,
	UNSTABLE_ToastContent as ToastContent,
	UNSTABLE_ToastQueue as ToastQueue,
	UNSTABLE_ToastRegion as ToastRegion,
} from "react-aria-components";

interface Content {
	icon: React.ReactNode;
	color: Color;
	message: React.ReactNode;
}

const variants = cva(
	"flex items-center rounded-3 border mt-2 inset-shadow-glow/20 bg-background gap-2 pl-3 pr-5 py-3.5",
	{
		variants: {
			color: {
				[Color.Blue]: "border-blue/20 text-blue inset-shadow-blue",
				[Color.Pink]: "border-pink/20 text-pink inset-shadow-pink",
				[Color.Purple]: "border-purple/20 text-purple inset-shadow-purple",
				[Color.Gray]: "border-grey/20 text-grey inset-shadow-grey",
				[Color.Yellow]: "border-yellow/20 text-yellow inset-shadow-yellow",
				[Color.Red]: "border-red/20 text-red inset-shadow-red",
				[Color.Orange]: "border-orange/20 text-orange inset-shadow-orange",
				[Color.Green]: "border-green/20 text-green inset-shadow-green",
				[Color.Cyan]: "border-cyan/20 text-cyan inset-shadow-cyan",
				[Color.White]: "border-white/20 text-white inset-shadow-white",
			},
		},
	},
);

export const queue = new ToastQueue<Content>();

export function Toasts() {
	return (
		<ToastRegion queue={queue} className="fixed bottom-20 right-4">
			{({ toast }) => (
				<Toast toast={toast}>
					<ToastContent
						className={cx(variants({ color: toast.content.color }))}
					>
						{toast.content.icon}
						<Text slot="title" className="text-foreground whitespace-nowrap">
							{toast.content.message}
						</Text>
					</ToastContent>
				</Toast>
			)}
		</ToastRegion>
	);
}
